<template>
    <v-container fluid>
        <div v-if="!dataLoading">
            <v-row>
                <v-col>
                    <h4 class="text-h4">Supplier #{{supplier.code}} - {{supplier.name}}</h4>
                    <p class="text-subtitle-1">Supplier Modification Form</p>
                    <v-divider></v-divider>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12" md="6">
                    <SupplierForm
                        ref="SupplierForm"
                        :value="supplier"
                        @submit="handleSubmit"
                        @error="handleError"
                        @loading="handleLoading"
                    />
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12" md="3">
                    <v-btn color="primary" block @click="handleSave" :loading="loading">
                        <v-icon left>mdi-content-save</v-icon>
                        save
                    </v-btn>
                </v-col>
                <v-col cols="12" md="3">
                    <v-btn depressed block  @click="handleDiscard">
                        cancel
                    </v-btn>
                </v-col>
            </v-row>
        </div>
        <div v-else>
            <v-row>
                <v-col>
                    <v-skeleton-loader type="heading" class="my-4"/>
                    <v-skeleton-loader type="text" class="my-4"/>
                    <v-divider></v-divider>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12" md="6">
                    <v-skeleton-loader type="text" class="my-4"/>
                    <v-skeleton-loader type="text" class="my-4"/>
                    <v-skeleton-loader type="text" class="my-4"/>
                    <v-skeleton-loader type="text" class="my-4"/>
                    <v-skeleton-loader type="text" class="my-4"/>
                    <v-skeleton-loader type="text" class="my-4"/>
                    <v-skeleton-loader type="text" class="my-4"/>

                </v-col>
            </v-row>
            <v-row>
                <v-col class="d-flex">
                    <v-skeleton-loader type="button" class="my-4 me-4"/>
                    <v-skeleton-loader type="button" class="my-4"/>
                </v-col>
            </v-row>
        </div>
        <PAlert v-bind="alert" v-model="alertShown"/>
    </v-container>
</template>

<script>
import permissions from './../../data/permissions';
import SupplierForm from './../../components/purchase/SupplierForm';
import PAlert from './../../components/common/PAlert';
import { mapActions, mapGetters } from 'vuex';

export default {
    name: "SupplierEditView",
    components: {
        SupplierForm,
        PAlert,
    },
    data() {
        return {
            id: null,
            supplier: {},
            alertShown: false,
            alert: {
                title: "Alert",
                content: "Are you sure?",
                callback: null
            },
            loading: false,
            dataLoading: false,
            perm: permissions
        }
    },
    computed: {
        ...mapGetters({
            hasPermission: "authentication/hasPermission"
        })
    },
    methods: {
        ...mapActions({
            find: "purchase/supplier/find",
            pushGroup: "purchase/supplierGroup/search/push",
            snackbar: "ui/snackbar/show",

        }),
        handleSave() {
            this.alert = { ...this.alert, content: "Are you sure you want to save?", callback: this.save };
            this.alertShown = true;
        },
        save() {
            this.$refs.SupplierForm.submit();
        },
        handleSubmit(supplier) {
            this.$router.push({name: "SupplierDisplay", params: { id: supplier.id }})
            this.snackbar({color: "success", text: "Supplier Updated Successfully!"});
        },
        handleError(err) {
            this.snackbar({color: "error", text: err});
        },
        handleLoading(value) {
            this.loading = value;
        },
        getSupplier() {
            this.dataLoading = true;
            this.find(this.id).then(response => {
                this.supplier = response.data;
                this.supplier.group_id = response.data.group.id;
                this.pushGroup(response.data.group);
            }).catch(error => {
                let message = error.response ? error.response.data.message : error;
                this.snackbar({color: "error", text: message});
            }).finally(() => {
                this.dataLoading = false;
            });
        },
        handleDiscard() {
            this.alert = {...this.alert, content: "are you sure you want to discard changes?", callback: this.discard};
            this.alertShown = true;
        },
        discard() {
            this.$router.back();
        }
    },
    created() {
        this.id = this.$route.params.id;
        this.getSupplier();
    },
    beforeRouteUpdate(to, from, next) {
        this.id = to.params.id;
        this.getSupplier();
        next();
    }
}
</script>

<style>

</style>